import React from 'react';
import { Divider } from 'antd';

const RibbtonSectionDivider = () => {
  return <Divider type='vertical' style={{ height: 40, margin: '4px 8px' }} />;
};

export default RibbtonSectionDivider;
